/**
 * TGAType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file TGAType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum TGAType {
	NO_DATA =      0,
	INDEXED =      1,
	RGB =          2,
	GREY =         3,
	RLE_INDEXED =  9,
	RLE_RGB =     10,
	RLE_GREY =    11
};